export function setPageHasChanges () {
  hasChanges = true
}

export function unsetPageHasChanges () {
  hasChanges = false
}

export const isPageHasChanges = () => 
  hasChanges

let hasChanges = false